module.exports = __webpack_public_path__ + "static/media/calendar.83eed14f.svg";